import React from "react";

export default function Custom404({ text = "" }) {
  return (
    <div className="view-image-custom d-flex align-items-center justify-content-center">
      <div className="not-found-wrapper">
        <p className="not-found-wrapper__not-found-text">{text}</p>
      </div>
    </div>
  );
}
